<template>
  <div id="modalCreateEditRole" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Cargo</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-sm-12">
                <label class="form-label">
                  Nome: <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': v$.role.name.$errors.length }"
                  placeholder="Nome do Cargo"
                  v-model="v$.role.name.$model"
                />
                <span
                  v-if="v$.role.name.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-sm-12">
                <label class="form-label">Descrição:</label>
                <textarea
                  class="form-control"
                  placeholder="Descrição do Cargo"
                  rows="5"
                  v-model="role.description"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'CreateEditRoleModal',

  props: {
    roleId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      role: {
        name: '',
        description: '',
      },
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.roleId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getRole() {
      try {
        this.role = await this.$store.dispatch('getRole', this.roleId)
        showModal('modalCreateEditRole')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          let response = null

          if (this.roleId) {
            response = await this.$store.dispatch('updateRole', this.role)
          } else {
            response = await this.$store.dispatch('saveRole', this.role)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      role: {
        name: {
          required,
        },
      },
    }
  },

  mounted() {
    if (this.roleId) {
      this.getRole()
    } else {
      showModal('modalCreateEditRole')
    }
  },
}
</script>
